import { render, staticRenderFns } from "./VoiceToneSection.vue?vue&type=template&id=4a5f73d3&scoped=true"
import script from "./VoiceToneSection.vue?vue&type=script&lang=js"
export * from "./VoiceToneSection.vue?vue&type=script&lang=js"
import style0 from "./VoiceToneSection.vue?vue&type=style&index=0&id=4a5f73d3&prod&lang=scss&scoped=true"
import style1 from "./VoiceToneSection.vue?vue&type=style&index=1&id=4a5f73d3&prod&lang=scss"
import style2 from "./VoiceToneSection.vue?vue&type=style&index=2&id=4a5f73d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f73d3",
  null
  
)

export default component.exports